import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { SmartSearchKeywordDirective } from 'mbs-ui-kit';
import { AgentType } from 'mbs-ui-shared@models/Computer';
import { of } from 'rxjs';
import { SmartSearchBaseTemplateComponent } from './smart-search-base-template.component';

@Component({
  selector: 'mbs-smart-search-agent-template',
  templateUrl: './smart-search-base-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  providers: [{ provide: SmartSearchKeywordDirective, useExisting: forwardRef(() => SmartSearchAgentTemplateComponent) }]
})
export class SmartSearchAgentTemplateComponent extends SmartSearchBaseTemplateComponent {
  public tag = 'Agent';
  public filterPropertyName = 'displayValue';
  constructor(public i18nPipe: I18NextPipe) {
    super(i18nPipe);
  }
  public items = () =>
    of(
      [AgentType.Backup, AgentType.RMM, AgentType.RA, AgentType.DeepInst].map((value) => ({
        value,
        searchText: value,
        displayValue: this.i18nPipe.transform(`shared:products.${value}`),
        translation: `shared:products.${value}`
      }))
    );
}
